module.exports = __webpack_public_path__ + "assets/42d32e919f1543919f7e594be59d5d22.png";